<template>
  <div class="forget-pwd tc form-common">
    <h3 class="title">Password Reset</h3>
    <form id="forget_pwd_form" class="tc layout-form" @submit.prevent="handleSendEmail()">
      <div class="input-group-wrap">
        <div class="input-group" :class="{ error: validation.hasError('nameOrEmail') || hasErrMsg}">
          <input
            class="w-100"
            type="text"
            placeholder="Your username or Email"
            v-model.trim="nameOrEmail"
            name="email"
            autocomplete="username email"
          />
        </div>
        <p class="error-msg tl">{{ validation.firstError('nameOrEmail') || errMsg}}</p>
      </div>
      <button :class="['btn', 'submit-btn', { loading: is_loading }]" type="submit" :style="disableBtn">SEND EMAIL</button>
    </form>
    <p class="remind">A password reset email has been sent to your inbox.</p>
    <p class="remind">If you do not receive your email within a few minutes, please try these options:</p>
    <div class="options-wrap remind">
      <ol class="options">
        <li class="options-item tl">
          Check your other folders, including spam and junk folder
        </li>
        <li class="options-item tl">
          Click the SEND EMAIL to resend the email
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import userService from '../service/userService';
import loading from '../../common/utils/loading';
import {validateError} from '../../common/utils/errors';
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);
export default {
  data() {
    return {
      is_loading: false,
      isUsername: false,
      isEmail: false,
      nameOrEmail: '',
      hasErrMsg:false,
      errMsg: '',
      userInfo:{

      }
    }
  },

  computed: {
    disableBtn() {
      if (this.validation.isPassed('nameOrEmail')) {
        return {
          opacity: 1,
        }
      } else {
        return {
          opacity: 0.3,
        }
      }
    },
  },

  validators: {
    nameOrEmail: function (value) {
      if (value.includes('@')) {
        this.isEmail = true;
        this.isUsername = false;
        return Validator.value(value).required().email()
      } else {
        this.isUsername = true;
        this.isEmail = false;
        return Validator.value(value).required()
      }
    },
  },

  mounted() {},

  methods: {
    handleSendEmail: function () {
      this.$validate().then((success) => {
        if (success) {
          this.clearErrMsg()
          if(this.is_loading) return;
          this.is_loading = true;
          loading.show();
          let info = this.isUsername ? {'username': this.nameOrEmail} : {'email': this.nameOrEmail}
          userService.sendForgetPwdEmail(info)
            .then(res=>{
              if(res.status == 0) {
                 this.hasErrMsg = true
                 this.errMsg = res.error.msg;
              }
            },err=>{
              if (err instanceof validateError) {
                const validate = err.getError();
                if(validate.username || validate.email) {
                  this.hasErrMsg = true
                  this.errMsg = validate.username || validate.email;
                }
              }
            })
            .finally(()=>{
              this.is_loading = false;
              loading.hide();
            })
        }
      })
    },

    /**
     * 清除校验信息
     */
    clearErrMsg: function () {
      this.hasErrMsg = false;
      this.errMsg = ''
    },
  },
}
</script>

<style></style>
